import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { SeicepService } from 'src/app/service/seicep.service';

@Component({
  selector: 'app-resultados-seicep',
  templateUrl: './resultados-seicep.component.html',
  styleUrls: ['./resultados-seicep.component.css']
})
export class ResultadosSeicepComponent implements OnInit {


  
  constructor(
    private api: apiService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
    public sanitizer: DomSanitizer,
    private seicepService: SeicepService,
  ) { }

  ngOnInit(): void {
   
  }


}
